import { z } from 'zod';
import { chartPreferencesTypeEnum, chartRecordSchema } from '../../types/chart-preferences';
export const createChartRecordRequestBodySchema = z.object({
    initialChartType: chartPreferencesTypeEnum,
});
export const createChartRecordResponseBodySchema = z.object({
    record: chartRecordSchema,
});
export const updateChartRecordOverrideParamsSchema = z.object({
    recordId: z.coerce.number(),
});
export const updateChartRecordOverrideRequestBodySchema = z.object({
    overrideChartTypes: z.array(chartPreferencesTypeEnum),
});
export const updateChartRecordOverrideResponseBodySchema = z.object({
    record: chartRecordSchema,
});
